import { createAction, props } from '@ngrx/store';
// import { LoginResponse } from '../../api/models';

export const authActions = {
  login: createAction('auth/login', props<{ email: string; password: string }>()),
  login_fail: createAction('auth/login/fail'),
  // login_success: createAction('auth/login/success', props<LoginResponse>()),
};
